import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getErrorStyle = (Control: StyledComponent, checked: boolean): SerializedStyles => css`
  ${Control} {
    box-shadow: none;

    ${checked
      ? css`
          background-color: ${Color.Red700};

          /* Check circle inside */
          &:before {
            background-color: ${Color.White};
          }
        `
      : css`
          border-color: ${Color.Red700};
        `};
  }
`
